import TasksExecsListByTask from './TasksExecsListByTask';
import groupsSearchCollector from '../../../../components/Hocs/GroupsSearchCollector';

export default groupsSearchCollector({
  newTasksList: {
    component: TasksExecsListByTask,
    listReduceName: 'tasksModule.lists.tasksExecsListByTask'
  }
});



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/TasksExecsListByTask/index.js